<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="trainingData"
      :loading="loading"
      :items-per-page="itemsPerPage"
      @page-count="pageCount = $event"
      :page.sync="page"
      item-key="id"
      :calculate-widths="true"
      hide-default-footer
      hide-default-header
    >
      <template v-slot:top> </template>

      <template v-slot:header="{ props: { headers } }">
        <thead>
          <tr>
            <th
              v-for="header in headers"
              :key="header.text"
              class="header--text center-text"
            >
              {{ header.text }}
            </th>
          </tr>
        </thead>
      </template>

      <template v-slot:item="{ index, item }">
        <tr class="center-tb">
          <td>{{ index + 1 }}</td>
          <td>{{ item.date }}</td>
          <td v-if="item.type == 1">On Job</td>
          <td v-else-if="item.type == 2">New</td>
          <td v-else>Refersher</td>
        </tr>
      </template>
    </v-data-table>
    <div class="text-center py-3">
      <v-pagination
        color="purple accent-4"
        v-model="page"
        :length="pageCount"
      ></v-pagination>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  props: {
    trainingData: {
      type: Array,
    },
  },
  components: {},
  data: () => ({
    pageCount: 0,
    page: 1,
    itemsPerPage: 10,
    item: {},
    headers: [
      { text: "No", value: "no" },
      { text: "Date", value: "date" },
      { text: "Type", value: "training_type_id" },
    ],
    type: null,
    date: null,
    trainingTypes: [
      { id: 1, name: "On Job" },
      { id: 2, name: "New" },
      { id: 3, name: "Refersher" },
    ],
  }),
  computed: {
    ...mapState("Loading", ["loading"]),
  },
  methods: {},
};
</script>

<style scoped>
.header--text {
  font-size: 17px !important;
  color: grey !important;
}
.v-expansion-panel:before {
  box-shadow: var(--box-shadow) !important;
}

.theme--light.v-expansion-panels
  .v-expansion-panel-header
  .v-expansion-panel-header__icon
  .v-icon {
  color: #fff !important;
}
</style>
